import { GuidedViewMenuResultMenuTree } from '../api/generated'

export const getGvOpenMenuEtelFamily = (
  menuTree: GuidedViewMenuResultMenuTree | undefined,
): string | null => {
  const menuLevel1 = menuTree?.subMenus
    ? menuTree?.subMenus.find((menu) => menu.isOpen === true)?.subMenus
    : null
  const menuLevel2 = menuLevel1
    ? menuLevel1?.find((menu) => menu.isOpen === true)?.subMenus
    : null
  const menuLevel3 = menuLevel2?.find((menu) => menu.isOpen === true)
  const firstEtelItem = menuLevel3?.leafItems ? menuLevel3.leafItems[0] : null
  const firstEtelItemString = firstEtelItem?.id.split('~')[0]

  if (!firstEtelItemString) {
    return null
  }
  const etelFamily = 'SUBMENU_' + firstEtelItemString

  return etelFamily
}
